import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { SharedModule } from "src/app/shared/shared.module";
import { DefaultComponent } from "./default.component";
import { ModalComponent } from "src/app/shared/modal/modal.component";
import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule } from "@angular/forms";
import { NgxSpinnerModule } from "ngx-spinner";
import { MatTabsModule } from '@angular/material/tabs';
import { MatRadioModule } from '@angular/material/radio';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { TableModule } from 'primeng/table';
import { DataViewModule } from "primeng/dataview";
import { ButtonModule } from "primeng/button";
import { DropdownModule } from "primeng/dropdown";
import { MultiSelectModule } from 'primeng/multiselect';
import { ToolbarModule } from "primeng/toolbar";
import { FileUploadModule } from "primeng/fileupload";
import { CardModule } from "primeng/card";
import { TooltipModule } from 'primeng/tooltip';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RippleModule } from 'primeng/ripple';
import { TimelineModule } from 'primeng/timeline';
import { TabViewModule } from 'primeng/tabview';
import { ListboxModule } from 'primeng/listbox';
import { DialogModule } from 'primeng/dialog';
import {ToggleButtonModule} from 'primeng/togglebutton';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { PickListModule } from 'primeng/picklist';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from "@angular/platform-browser";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { DocumentsComponent } from "src/app/components/documents/documents.component";
import { ConfirmMailComponent } from "src/app/components/confirm-mail/confirm-mail.component";
import { HomeComponent } from "src/app/components/home/home.component";
import { LoadDocumentsComponent } from "src/app/components/load-documents/load-documents.component";
import { TestServicesComponent } from "src/app/components/test-services/test-services.component";
import { AttachmentComponent } from "src/app/attachment/attachment.component";
import { AutorizacionComponent } from "src/app/components/autorizacion/autorizacion.component";
import { ParameterComponent } from 'src/app/components/parameter/parameter.component';
import { UserComponent } from 'src/app/components/user/user.component';
import { ProfileComponent } from "src/app/components/profile/profile.component";
import { IconsByTypePipe } from "src/app/attachment/icons-by-type.pipe";
import { LoadFilesComponent } from "src/app/components/load-files/load-files.component";
import { NgxDropzoneModule } from 'ngx-dropzone';
declare module "@angular/core" {
  interface ModuleWithProviders<T = any> {
    ngModule: Type<T>;
    providers?: Provider[];
  }
}

@NgModule({
  declarations: [
    DefaultComponent,
    HomeComponent,
    DocumentsComponent,    
    LoadDocumentsComponent,
    TestServicesComponent,
    ModalComponent,
    ConfirmMailComponent,
    AttachmentComponent,    
    IconsByTypePipe,
    ParameterComponent,
    LoadFilesComponent,
    UserComponent,
    ProfileComponent,
    AutorizacionComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    FormsModule,
    NgxSpinnerModule,
    ReactiveFormsModule,
    BrowserModule,
    NgbModule,
    TableModule,
    MatTabsModule,
    MatRadioModule,
    MatMenuModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatTooltipModule,
    MatDialogModule,
    MatListModule,
    MatCardModule,
    ToggleButtonModule,
    ButtonModule,
    DropdownModule,
    ToolbarModule,
    FileUploadModule,
    DataViewModule,
    CardModule,
    TooltipModule,
    MultiSelectModule,
    CalendarModule,
    InputTextModule,
    CheckboxModule,
    RadioButtonModule,
    RippleModule,
    TimelineModule,
    ButtonModule,
    TabViewModule,
    ListboxModule,
    DialogModule,
    AutoCompleteModule,
    PickListModule,
    BrowserAnimationsModule,
    NgxDropzoneModule
    
  ],
  exports: [DefaultComponent],
})
export class DefaultModule { }
